import { Pipe, PipeTransform } from '@angular/core'
import { fileUrl } from './file-url'

/**
 * Builds the stable public URL for a file (public content: ads, banners,
 * avatars, videos) synchronously — no API round-trip. The object itself is
 * served with immutable Cache-Control headers, so the browser caches it.
 *
 * ```html
 * <img [src]="ad.firstFileId | fileLink" />
 * ```
 *
 * For private files (chat attachments) use `privateFileLink` instead.
 */
@Pipe({
	name: 'fileLink',
	standalone: true,
})
export class FileLinkPipe implements PipeTransform {
	public transform(fileDomainId: string | null | undefined): string | null {
		return fileUrl(fileDomainId)
	}
}
